
import { declareVrunComponent } from '/vodalys/vvuejs/declareVrunComponent.mjs'

declareVrunComponent('visio2Capture.vrun.component', () => import('./components/Visio2Capture.vue'))



